import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFire2 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#FFC700",
		stroke: "#FF5353",
		strokeWidth: .722171,
		d: "M14.8487 13.06C14.5441 15.4393 12.5 17 10.3947 17C8 17 6.43048 15.1002 6.11217 13.2694C5.79385 11.4386 6.11217 10.3573 7.17807 9.29136C7.90135 8.56808 9.17662 7.33089 9.7857 4C13.9541 7.959 15.1532 10.6808 14.8487 13.06Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#FF5353",
		d: "M7.74137 12.1867C7.3101 13.9081 8.20038 15.3347 9.35867 15.9165C12.0854 16.6375 13.2648 14.5119 13.2648 12.6263C13.2648 11.1092 12.6057 10.2398 11.0175 8.23135C11.5566 10.8341 11.0175 12.3711 9.93924 12.3711C8.86767 11.8371 9.45543 10.5881 9.17205 10.2398C8.77809 10.5677 7.9404 11.4161 7.74137 12.1867Z"
	})]
});
const ForwardRef = forwardRef(SvgFire2);
export default ForwardRef;
